import { create } from 'zustand';
import { v4 as uuidv4 } from 'uuid';

const useNotificationStore = create((set) => ({
  notifications: [],
  addNotification: (type, message, duration = 3000) => {
    const id = uuidv4();
    set((state) => ({
      notifications: [...state.notifications, { id, type, message }]
    }));
    
    if (duration > 0) {
      setTimeout(() => {
        set((state) => ({
          notifications: state.notifications.filter((n) => n.id !== id)
        }));
      }, duration);
    }
  },
  removeNotification: (id) => {
    set((state) => ({
      notifications: state.notifications.filter((n) => n.id !== id)
    }));
  }
}));

export default useNotificationStore;